import styled from "styled-components";

const RightSessionText = styled.p`
  color: #fff;
  font-size: 12px;
  margin-bottom: 10px;
  line-height: normal;
`;
export default RightSessionText;
